import { GPD, Report, VolumeSeries } from "@nens/brostar/openapi-client";
import {
  EditGPDAddReportTask,
  EditGPDStartRegistrationTask,
  GpdMethodOptions,
  GpdTemperatureOptions,
  GpdWaterInOutOptions,
  gpdMethodOptions,
  gpdTemperatureOptions,
  gpdWaterInOutOptions,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";
import { toDateString } from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

function isGpdMethod(value: string): value is GpdMethodOptions {
  return gpdMethodOptions.some((option) => option.value === value);
}

function isGpdWaterInOut(value: string): value is GpdWaterInOutOptions {
  return gpdWaterInOutOptions.some((option) => option.value === value);
}

function isGpdTemperature(value: string): value is GpdTemperatureOptions {
  return gpdTemperatureOptions.some((option) => option.value === value);
}

export const convertGPDToEditTask = ({
  deliveryAccountableParty,
  qualityRegime,
  broId,
}: GPD): EditGPDStartRegistrationTask => {
  return {
    metadata: {
      broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      objectIdAccountableParty: "",
      publiclyAvailable: "",
    },
  };
};

export const convertGPDReportToEditTask = (
  report: Report,
  gpd: GPD,
  volumeSeries: VolumeSeries[]
): EditGPDAddReportTask => {
  return {
    metadata: {
      broId: gpd.broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, gpd.qualityRegime),
      deliveryAccountableParty: gpd.deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      reportId: report.reportId ?? "",
      method: isGpdMethod(report.method) ? report.method : "onbekend",
      groundwaterUsageFacilityBroId: report.groundwaterUsageFacilityBroId ?? "",
      volumeSeries: volumeSeries.map((series) => ({
        waterInOut: isGpdWaterInOut(series.waterInOut) ? series.waterInOut : "onttrokken",
        volume: Number.isFinite(series.volume) ? series.volume : 0,
        temperature: isGpdTemperature(series.temperature) ? series.temperature : undefined,
        beginDate: toDateString(series.beginDate),
        endDate: toDateString(series.endDate),
      })),
    },
    volumeFile: new Blob([]),
  };
};
